module.exports = __webpack_public_path__ + "fonts/c648494abae75ac8cee4b902beece50c.svg";